<div class="row row-header">
	<div class="col">

		<h1 data-testid="SUBSYS5_PATSETTINGS_TITLE_TXT" class="mb-5">{{ labels().PATIENT_SETTINGS_COMPONENT_TITLE }}</h1>

		<div class="panel mb-0">
			<h4 data-testid="SUBSYS5_PATSETTINGS_PATIENT_TXT" class="wrapper-title-span">
				{{ labels().PATIENT_SETTINGS_COMPONENT_TITLE_PATIENT_ID }}:<span>{{ patient()?.number }}</span>
			</h4>
		</div>

	</div>
</div>

<div class="row row-contents">
	<div class="col">

		@if (isVisible()) {

		<div class="row my-5">
			<div class="col-12">
				<tsp-contact-info [emailAddress]="contactInfo()" (emailAddressChange)="updateEmail($event)"
					[secondEmailAddress]="secondContactInfo()" (secondEmailAddressChange)="updateSecondEmail($event)"
					(isValid)="isContactInfoValid.set($event)" [isReadonly]="isReadonly()" />
			</div>
		</div>
		<div class="mt-5">
			<tsp-pin-site-care [isEnabled]="isPinSiteCareEnabled()" (isEnabledChange)="enablePinSiteCare($event)"
				[firstDay]="firstDay()" (firstDayChange)="updateFirstDay($event)" [frequency]="frequency()"
				(frequencyChange)="updateFrequency($event)" (isValid)="isPinSiteCareValid.set($event)" />
		</div>

		<!-- <ng-container [ngTemplateOutlet]="patAccordion" [ngTemplateOutletContext]="{ 
			title: labels().PATIENT_SETTINGS_COMPONENT_TITLE_PDF_PINSITECARE, 
			isOpened: pdfPinSiteCareOpened,
			content: pinsitecarePdf 
			}">
		</ng-container>
		<ng-template #pinsitecarePdf>
			<tsp-pdf-uploader [title]="labels().PATIENT_SETTINGS_COMPONENT_TITLE_PDF_PINSITECARE"
				[fileName]="pinSiteCarePdf()?.name" [useFile]="true" (fileChanged)="updatePinSiteCareFile($event)" />
		</ng-template> -->

		<ng-container [ngTemplateOutlet]="patAccordion" [ngTemplateOutletContext]="{ 
			title: labels().PATIENT_SETTINGS_COMPONENT_TITLE_MESSAGES, 
			isOpened: msgOpened,
			content: motMessages 
			}">
		</ng-container>
		<ng-template #motMessages>
			<tsp-motivational-messages [data]="motMessagesData()" (isEnabledChange)="enableMotMessages($event)"
				(selectedSetChange)="updateCustomSet($event)" (enableSetChange)="updateEnableSet($event)"
				(isValid)="isMotMessagesValid.set($event)" />
		</ng-template>

		<!-- <ng-container [ngTemplateOutlet]="patAccordion" [ngTemplateOutletContext]="{ 
			title: labels().PATIENT_SETTINGS_COMPONENT_TITLE_PDF_PHYSIOTHERAPY, 
			isOpened: pdfPhysioOpened,
			content: physioPdf 
			}">
		</ng-container>
		<ng-template #physioPdf>
			<tsp-pdf-uploader [title]="labels().PATIENT_SETTINGS_COMPONENT_TITLE_PDF_PHYSIOTHERAPY"
				[fileName]="physiotherapyPdf()?.name" [useFile]="true" (fileChanged)="updatePhysiotherapyFile($event)" />
		</ng-template> -->

		@if (publishedPlans()?.length) {
		<ng-container [ngTemplateOutlet]="patAccordion" [ngTemplateOutletContext]="{ 
				title: labels().PATIENT_SETTINGS_COMPONENT_TITLE_PROGRESS, 
				isOpened: progressOpened,
				content: publishedProgress 
				}">
		</ng-container>
		<ng-template #publishedProgress>
			<tsp-published-plans-progress [publishedPlans]="publishedPlans()" />
		</ng-template>
		}

		}
		<div class="bottom-bar-save bottom-bar-save-plan">
			<button data-testid="SUBSYS5_PATSETTINGS_CANCEL_BTN" type="button" class="btn btn-secondary-outline" (click)="cancel()">
				{{ labels().PATIENT_SETTINGS_COMPONENT_CANCEL_BUTTON }}
			</button>
			@if (isBtnVisible()) {
			<button data-testid="SUBSYS5_PATSETTINGS_REVOKEALL_BTN" type="button" class="btn btn-primary btn-red"
				[disabled]="!isRevokeEnabled()" (click)="openRevokeAllModal()">
				{{ labels().PATIENT_SETTINGS_COMPONENT_REVOKEALL_BUTTON }}
			</button>
			<button data-testid="SUBSYS5_PATSETTINGS_UPDATE_BTN" type="button" class="btn btn-primary ms-3"
				[disabled]="!isUpdateEnabled()" (click)="update()">
				{{ labels().PATIENT_SETTINGS_COMPONENT_UPDATE_BUTTON }}
			</button>
			}
		</div>

	</div>
</div>

<ng-template #patAccordion let-title="title" let-isOpened="isOpened" let-content="content">
	<div class="panel panel-thead mt-4 mb-1" (click)="accordion.toggle()" (keypress)="accordion.toggle()">
		<div class="row no-gutters">
			<div class="col short-col">
				<span class="material-icons panel-toggle align-middle">
					{{ isOpened ? 'expand_less' : 'expand_more'}}
				</span>
			</div>
			<div class="col text-start">
				<h3 class="mb-0">{{ title }}</h3>
			</div>
		</div>
	</div>
	<div #accordion="ngbCollapse" [ngbCollapse]="!isOpened">
		<div class="panel mb-1">
			<ng-container *ngTemplateOutlet="content" />
		</div>
	</div>
</ng-template>